export default [
  {
    path: "/service-warehouses",
    name: "service-warehouses",
    component: () =>
      import("@/modules/service-warehouses/ServiceWarehouses.vue"),
    children: [
      {
        path: "list",
        name: "list-service-warehouses",
        component: () =>
          import(
            "@/modules/service-warehouses/pages/ServiceWarehousesList.vue"
          ),
        meta: { permissions: ["service-show"] }
      },
      {
        path: "add",
        name: "add-service-warehouses",
        component: () =>
          import("@/modules/service-warehouses/pages/ServiceWarehousesAdd.vue"),
        meta: { permissions: ["service-create"] }
      },
      {
        path: "edit/:id",
        name: "edit-service-warehouses",
        component: () =>
          import(
            "@/modules/service-warehouses/pages/ServiceWarehousesEdit.vue"
          ),
        meta: { permissions: ["service-update"] }
      }
    ]
  }
];
